import Box from "ds/components/Box";
import useTypedContext from "hooks/useTypedContext";
import { ThemeContext, ThemePalette } from "views/Theme";
import SegmentedControl from "ds/components/SegmentedControl";
import { Theme } from "types/Theme";

import styles from "./styles.module.css";

const options: Array<{
  value: ThemePalette | "system";
  label: string;
}> = [
  { value: Theme.Light, label: "Light" },
  { value: Theme.Dark, label: "Dark" },
  { value: Theme.HighContrastLight, label: "HC Light" },
  { value: Theme.HighContrastDark, label: "HC Dark" },
  { value: "system", label: "System" },
];

const DevToolsTheme = () => {
  const { currentTheme, changeTheme, syncThemeWithSystem, setSyncThemeWithSystem } =
    useTypedContext(ThemeContext);

  return (
    <Box align="start">
      <SegmentedControl
        options={options}
        value={syncThemeWithSystem ? "system" : currentTheme}
        optionClassName={styles.themeSwitchOption}
        onChange={(value) => {
          if (value === "system") {
            setSyncThemeWithSystem(true);
          } else {
            setSyncThemeWithSystem(false);
            changeTheme(value);
          }
        }}
      />
    </Box>
  );
};

export default DevToolsTheme;
